import clsx from 'clsx';

interface CurrencyDisplayProps {
  value: number;
  showCents?: boolean;
  className?: string;
}

export function CurrencyDisplay({ value, showCents = false, className }: CurrencyDisplayProps) {
  const isNegative = value < 0;
  const absValue = Math.abs(value);

  const formatted = absValue.toLocaleString('en-US', {
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0,
  });

  const display = isNegative ? `(${formatted})` : formatted;

  return (
    <span
      className={clsx(
        'tabular-nums',
        isNegative && 'text-red-600',
        className,
      )}
    >
      {display}
    </span>
  );
}

export function formatCurrency(value: number, showCents: boolean = false): string {
  const isNegative = value < 0;
  const absValue = Math.abs(value);
  const formatted = absValue.toLocaleString('en-US', {
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0,
  });
  return isNegative ? `(${formatted})` : formatted;
}

export function formatPercent(value: number, decimals: number = 1): string {
  return `${(value * 100).toFixed(decimals)}%`;
}
